import { ref } from 'vue'

const button = ref<boolean>(false)
const snapped = ref<boolean>(false)
const snapshotData = ref<string>(null)
const snapshotQR = ref<string>(null)

export const useStoreSnapshot = () => {
  const enableButton = (status: boolean) => {
    button.value = status
  }

  const hasSnapped = (status: boolean) => {
    snapped.value = status
  }

  const updateSnapshotData = (data: string) => {
    snapshotData.value = data
  }

  const updateQRLink = (data: string) => {
    snapshotQR.value = data
  }

  return {
    enableButton,
    hasSnapped,
    updateSnapshotData,
    updateQRLink,
    button,
    snapped,
    snapshotData,
    snapshotQR
  }
}
